const isMainNavEnabled = false;

export default [
  {
    path: "ChooseOperation",
    name: "Choose Operation",
    component: () => import("../views/ChooseOperation.vue"),
    meta: { mainNavEnabled: false, },
    //redirect: "helloworld",
  },
  {
    path: "MultiSelect",
    name: "Multi Select",
    component: () => import("../views/MultiSelect.vue"),
    meta: { mainNavEnabled: false, },
  },
  {
    path: "ImportExcel/:value",
    name: "Browse and upload your file",
    component: () => import("../views/ImportExcel.vue"),
    meta: { mainNavEnabled: false, },
    props: true,
    //redirect: "helloworld",
  },
  {
    path: "unauthorized",
    name: "Unauthorized",
    component: () => import("../views/Unauthorized.vue"),
    meta: { mainNavEnabled: false, },
    //redirect: "helloworld",
  },
];
